import { TagState } from '@app/component/tag/TagState';


export const findSentimentTextColorClass = (num: number) => {
	if(num >= 900) return 'text-green-600';
	if(num >= 800) return 'text-blue-600';
	if(num >= 700) return 'text-amber-600';
	if(num > 0) return 'text-red-600';
	return 'text-gray-600';
}

export const findSentimentTagState = (num: number): TagState => {
	if(num >= 900) return 'success';
	if(num >= 800) return 'info';
	if(num >= 700) return 'warning';
	if(num > 0) return 'critical';
	return 'none';
}

export const findSentimentBackgroundClass = (num: number) => {
	if(num >= 900) return 'bg-green-100';
	if(num >= 800) return 'bg-blue-100';
	if(num >= 700) return 'bg-amber-100';
	if(num > 0) return 'bg-red-100';
	return 'bg-gray-100';
}